// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__nwnXt","selects":"Documents_selects__1qEm-"};